// A timeline row's React key across a send's confirmation (perf pass 2026-10-17; the Mac's
// `MacMessageTimeline.confirmedRenames`). A sent message is drawn first as an echo / pending row
// keyed by its pendingId; the server's post then REPLACES it under a new id. Keyed by `post.id`, React
// unmounted the row and mounted a new one — its DOM, images and measured height thrown away at the
// very moment the reader is looking at it. The confirmation is a RENAME of the same row: once a
// stored post names the pendingId it came from, that post keeps the pendingId's key for the
// conversation's lifetime (even after a later refetch no longer carries `pending_post_id`).

export class RowKeys {
  private readonly renames = new Map<string, string>();

  key(post: { id: string; pendingId?: string | null }): string {
    if (post.pendingId && post.pendingId !== post.id && !this.renames.has(post.id)) this.renames.set(post.id, post.pendingId);
    return this.renames.get(post.id) ?? post.id;
  }
}
